export enum MessageType {
  Agent = 'agent',
  User = 'user',
}
